import { render, staticRenderFns } from "./togglebox.vue?vue&type=template&id=59b6ebda&scoped=true&lang=pug&"
import script from "./togglebox.vue?vue&type=script&lang=js&"
export * from "./togglebox.vue?vue&type=script&lang=js&"
import style0 from "./togglebox.vue?vue&type=style&index=0&id=59b6ebda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b6ebda",
  null
  
)

export default component.exports